var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZengradeLogoNobackgroundDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "#000",
      fill: "#fdfdfd"
    },
    cx: 7.479,
    cy: 8.037,
    rx: 5.423,
    ry: 5.008
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1C-2.2 4-.2 15.3 8 15.3c4.1 0 7.3-3.2 7.3-7.3 0-5-5.3-8.8-9.8-7zM10 5.7c.2.2-.2 1.4-.9 2.6-1.3 2-1.3 2.1.3.8.9-.8 2-1.1 2.4-.7.8.9-2.6 3.6-4.4 3.6-2 0-2.7-1.9-1.4-3.5C7 7.3 6.9 7 5.6 7c-1.7 0-2.1-1.2-.9-2.3.6-.7 4.2 0 5.3 1z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZengradeLogoNobackgroundDeactivated);
export default __webpack_public_path__ + "static/media/zengrade-logo-nobackground-deactivated.79ffd1663c6d60d7bda886fc294278f3.svg";
export { ForwardRef as ReactComponent };